import React, { FC } from 'react';
import { useReframe } from 'nike-re-framejs';
import { liveMatchPenaltiesHome$, liveMatchPenaltiesAway$ } from '../../liveSubs';
import clsx from 'clsx';
import './MatchPenalty.less';

const MatchPenalty: FC<{ penalty: number; otherClass?: string }> = ({ penalty, otherClass }) =>
    penalty && penalty > 0 ? (
        <span className={clsx('match-penalty flex-inline items-center justify-center flex-shrink-0', otherClass)}>
            {penalty}
        </span>
    ) : null;

export const MatchPenaltyHome: FC<{ eventId: number; otherClass?: string }> = ({ eventId, otherClass }) => {
    const derefSub = useReframe();
    const penaltyHome = derefSub(liveMatchPenaltiesHome$(eventId));
    return <MatchPenalty penalty={penaltyHome} otherClass={otherClass} />;
};

export const MatchPenaltyAway: FC<{ eventId: number; otherClass?: string }> = ({ eventId, otherClass }) => {
    const derefSub = useReframe();
    const penaltyAway = derefSub(liveMatchPenaltiesAway$(eventId));
    return <MatchPenalty penalty={penaltyAway} otherClass={otherClass} />;
};
